import React from "react";

// Interfaces
import { IdentityErrorHelperProps } from "@/screen/Identities/Interfaces/IdentityFormInterfaces";

// Styles
import { ErrorHelperContainer, ErrorListContainer, ErrorListTitle, ErrorList, ErrorItem } from "@/screen/Identities/Styles/IdentityFormStyles";

const IdentityErrorHelper: React.FC<IdentityErrorHelperProps> = ({errors, errorsRef}) =>
{
    if(errors.length === 0)
    {
        return null;
    }

    return(
        <ErrorHelperContainer ref={errorsRef} tabIndex={-1}>
            <ErrorListContainer>
                <ErrorListTitle>
                    Revisa la siguiente información
                </ErrorListTitle>
                <ErrorList>
                    {errors.map((error, index) =>
                    (
                        <ErrorItem key={index} style={{cursor: "default"}}>
                            {error.message}
                        </ErrorItem>
                    ))}
                </ErrorList>
            </ErrorListContainer>
        </ErrorHelperContainer>
    );
};

export default IdentityErrorHelper;